import debounce                     from 'lodash.debounce';
import {
  ISelectableEntity,
}                                   from '../DataTypes';
import EntityListModel              from './EntityListModel';

export abstract class RoutedEntityListModel<TState = unknown> extends EntityListModel<TState> {
  navigateToDebounced: (id: string) => void;

  constructor() {
    super();
    this.navigateToDebounced = debounce(this.navigateTo.bind(this), 300, { leading: false });
  }

  abstract makeLink(id: string): string

  abstract navigateTo(entityId?: string): void

  protected abstract getTitle(e?: ISelectableEntity): string

  protected updateSelectionInList() {
    if (!this.selectedEntity) return;
    const entity: ISelectableEntity | undefined = this.getEntity(this.selectedEntity.id);
    if (!entity) {
      this.selectedEntity = undefined;
      this.navigateTo();
    } else {
      entity.isSelected = true;
    }
  }

  select(e?: ISelectableEntity) {
    super.select(e);
    this.updateTitle(e);
  }

  protected updateTitle(e?: ISelectableEntity) {
    const newTitle = this.getTitle(e);
    if (window.document.title !== newTitle) {
      window.document.title = newTitle;
    }
  }

  moveHome(): ISelectableEntity {
    const entity = super.moveHome();
    this.navigateToDebounced(entity.id);
    return entity;
  }

  moveEnd(): ISelectableEntity {
    const entity = super.moveEnd();
    this.navigateToDebounced(entity.id);
    return entity;
  }

  moveNext(): ISelectableEntity {
    const entity = super.moveNext();
    this.navigateToDebounced(entity.id);
    return entity;
  }

  movePrevious(): ISelectableEntity {
    const entity = super.movePrevious();
    this.navigateToDebounced(entity.id);
    return entity;
  }
}

export default RoutedEntityListModel;
